import CircleBackButton from "~/icons/CircleBackIcon";

import styles from "./BackButton.module.css";

type BackButtonProps = {
  text: string;
  onClick: VoidFunction;
};

const BackButton: React.FC<BackButtonProps> = ({ text, onClick }) => {
  return (
    <div className={styles.wrapper} onClick={onClick}>
      <CircleBackButton />
      <span>{text}</span>
    </div>
  );
};

export default BackButton;
